<div id="mainContainer">
  <app-public-header></app-public-header>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
